import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";

export default function HomePage() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView(), 60);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <Hero />
      <Services />
      <About />
      <Contact />
    </>
  );
}
